import { AppBar, Card, CardHeader, Stack, Tab, Tabs } from "@mui/material";
import DashboardLayout from "../layoutcontainers/DashboardLayout";
import MaterialButton from "../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialTypography from "../components/MaterialTypography";
import MaterialSelect from "../components/MasterSelect";
import { useEffect, useState } from "react";
import MaterialBox from "../components/MaterialBox";
import MaterialDataGrid from "../components/MaterialDataGrid";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../pages/Utils/Baseurl";
import { useUserDetails } from "../context/auth";
const StaffRequestTable = () => {
  const nav = useNavigate();
  const userdata = sessionStorage.getItem("user");
  const parsedData = JSON.parse(userdata);
  const empid = parsedData.empid;
  // const userid = "Q3VzdG9tVXNlclZpZXc6" + btoa(parsedData.id);
  const userid = parsedData.id;
  console.log(userid, "userid");

  const { AccessData } = useUserDetails();
  const department = {
    value: "",
  };

  const handleclick = () => {
    nav("/staff-request/create-Staffrequest");
  };
  const [Department, SetDepartment] = useState({ value: "All", label: "All" });
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [Status, setStatus] = useState({
    value: "All",
    label: "All",
  });

  const [tabledata, settabledata] = useState([]);
  const [sampledata, setsampledata] = useState([]);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal"); //Used to store the orientation of the tabs
  const [tabValue, setTabValue] = useState("mylist"); //Used to store current selected tab

  console.log(tabledata, "tabledata33");

  useEffect(() => {
    // onDepartmentSubmit();
    fetchstaffrequest();
    onDepartmentdata();
    const tabName = JSON.parse(sessionStorage.getItem("staffReqApp"));

    if (tabName) {
      setTabValue(tabName);
    } else {
      setTabValue("mylist");
    }
  }, []);

  useEffect(() => {
    setStatus({
      value: "All",
      label: "All",
    });
    fetchstaffrequest();
  }, [tabValue]);

  const SalaryStructureListTable = {
    columns: [
      {
        field: "sno",
        headerName: "S.No",
        width: 70,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "jobid",
        headerName: "Job ID",
        width: 140,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "requestDate",
        headerName: "Requested Date",
        width: 160,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "role",
        headerName: "Role",
        width: 160,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      // {
      //   field: "responsiblePerson",
      //   headerName: "Responsible Person",
      //   width: 160,
      //   editable: false,
      //   disableColumnMenu: true,
      //   sortable: true,
      // },
      {
        field: "employmentType",
        headerName: "Employee Type",
        width: 160,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "approvalStatus",
        headerName: "Approval Status",
        width: 160,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "jobStatus",
        headerName: "Job Status",
        width: 160,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
    ],

    rows: tabledata
      ?.slice()
      .reverse()
      .map((leave, index) => ({
        sno: index + 1,
        id: leave.id,
        jobid: leave.jobid,
        requestDate: leave.requestDate,
        role: leave.role,
        responsiblePerson: leave.responsiblePerson,
        employmentType: leave.employmentType,
        approvalStatus: (
          <span
            style={{
              color:
                leave.approvalStatus === "Recruitment in progress"
                  ? "#f7dc6f" // Dark Green
                  : leave.approvalStatus === "Rejected"
                    ? "#e74c3c" // Dark Red
                    : leave.approvalStatus === null
                      ? "#f39c12" // Orange for Pending
                      : "#000",
              fontWeight: 600,
              padding: "6px 12px",
              textAlign: "center",
            }}
          >
            {leave.approvalStatus === null
              ? "Waiting for Approval "
              : leave.approvalStatus}
          </span>
        ),

        jobStatus: leave.jobStatus,
      })),
  };
  console.log("sampledatasampledata:", tabledata);

  const handlechange = async (selectedOption) => {
    console.log(selectedOption, "seloptt");
    console.log(tabledata, "tabdata");

    if (selectedOption.value == "All") {
      console.log(sampledata, "samdatga");

      settabledata(sampledata);
    } else {
      const filtereddata = sampledata.filter(
        (data) => data.statusapproval === selectedOption.value,
      );

      settabledata(filtereddata);
    }

    setStatus(selectedOption);
  };

  const fetchstaffrequest = async () => {
    if (tabValue == "mylist") {
      console.log("inside my list");

      const query = `query staffRequestByEmpid($empId: String!) {
  staffRequestByEmpid(empid: $empId) {
  id
    jobid
    requestDate	
    teamName
    teamLeadName
    projectName
    startDate
    role
    salaryLpa
    experience
    employmentType
    approvalStatus
    jobStatus
    keySkills
    priority
    noOfPositions
    preference
    interviewPannel
    noOfRounds
    responsiblePerson
    positionStatus
    jd
    justificationForRequest
    empid
		manuallyAdd
  }
}`;

      try {
        // setPageState({ ...pageState, loading: true });
        setPageState((prev) => ({ ...prev, loading: true }));
        const response = await axios.post(
          BASEURL,
          {
            query,
            variables: {
              empId: empid,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        let result = response.data.data.staffRequestByEmpid.filter(
          (item) => item?.manuallyAdd === false,
        );
        console.log("resultresult:", result);

        result =
          result
            ?.slice()
            .reverse()
            .map((leave, index) => ({
              sno: index + 1,
              id: leave.id,
              jobid: leave.jobid,
              requestDate: leave.requestDate,
              role: leave.role,
              responsiblePerson: leave.responsiblePerson,
              employmentType: leave.employmentType,
              statusapproval: leave.approvalStatus || "Waiting for Approval",
              approvalStatus: (
                <span
                  style={{
                    color:
                      leave.approvalStatus === "Recruitment in progress"
                        ? "#f7dc6f" // Dark Green
                        : leave.approvalStatus === "Rejected"
                          ? "#e74c3c" // Dark Red
                          : leave.approvalStatus === null
                            ? "#f39c12" // Orange for Pending
                            : "#000",
                    fontWeight: 600,
                    padding: "6px 12px",
                    textAlign: "center",
                  }}
                >
                  {leave.approvalStatus === null
                    ? "Waiting for Approval "
                    : leave.approvalStatus}
                </span>
              ),

              jobStatus: leave.jobStatus,
            })) || [];

        console.log(result, "dataress");
        setsampledata(result);
        settabledata(result);

        setPageState((prev) => ({ ...prev, loading: false, state: "success" }));
      } catch (error) {
        console.error("ResponseError:", error);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else if (tabValue == "teamlist") {
      console.log("inside team list");

      const query = `query staffRequestByTeamleaderId($teamleaderId: String!) {
  staffRequestByTeamleaderId(teamleaderId: $teamleaderId) {
  id
		jobid
    requestDate	
    teamName
    teamLeadName
    projectName
    startDate
    role
    salaryLpa
    experience
    employmentType
    approvalStatus
    jobStatus
    keySkills
    priority
    noOfPositions
    preference
    interviewPannel
    noOfRounds
    responsiblePerson
    positionStatus
    jd
    justificationForRequest
    empid
		manuallyAdd
  }
}`;

      try {
        // setPageState({ ...pageState, loading: true });
        setPageState((prev) => ({ ...prev, loading: true }));
        const response = await axios.post(
          BASEURL,
          {
            query,
            variables: {
              teamleaderId: userid,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        let result = response.data.data.staffRequestByTeamleaderId.filter(
          (item) => item?.manuallyAdd === false,
        );
        console.log("resultresult:", result);

        result = result
          ?.slice()
          .reverse()
          .map((leave, index) => ({
            sno: index + 1,
            id: leave.id,
            jobid: leave.jobid,
            requestDate: leave.requestDate,
            role: leave.role,
            responsiblePerson: leave.responsiblePerson,
            employmentType: leave.employmentType,
            statusapproval: leave.approvalStatus || "Waiting for Approval",
            approvalStatus: (
              <span
                style={{
                  color:
                    leave.approvalStatus === "Recruitment in progress"
                      ? "#f7dc6f" // Dark Green
                      : leave.approvalStatus === "Rejected"
                        ? "#e74c3c" // Dark Red
                        : leave.approvalStatus === null
                          ? "#f39c12" // Orange for Pending
                          : "#000",
                  fontWeight: 600,
                  padding: "6px 12px",
                  textAlign: "center",
                }}
              >
                {leave.approvalStatus === null
                  ? "Waiting for Approval "
                  : leave.approvalStatus}
              </span>
            ),

            jobStatus: leave.jobStatus,
          }));
        settabledata(result);
        setsampledata(result);

        setPageState((prev) => ({ ...prev, loading: false, state: "success" }));
      } catch (error) {
        console.error("ResponseError:", error);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else {
      const query = `query {
        allStaffRequests {
          id
          jobid
          requestDate
          teamName
          teamLeadName
          projectName
          startDate
          role
          salaryLpa
          experience
          employmentType
          approvalStatus
          jobStatus
          keySkills
          priority
          noOfPositions
          preference
          interviewPannel
          noOfRounds
          responsiblePerson
          positionStatus
          jd
          justificationForRequest
          empid
          manuallyAdd
        }
      }`;

      try {
        // setPageState({ ...pageState, loading: true });
        setPageState((prev) => ({ ...prev, loading: true }));
        const response = await axios.post(
          BASEURL,
          {
            query,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        let result = response.data.data.allStaffRequests.filter(
          (item) => item?.manuallyAdd === false,
        );
        console.log("resultresult:", result);

        result = result
          ?.slice()
          .reverse()
          .map((leave, index) => ({
            sno: index + 1,
            id: leave.id,
            jobid: leave.jobid,
            requestDate: leave.requestDate,
            role: leave.role,
            responsiblePerson: leave.responsiblePerson,
            employmentType: leave.employmentType,
            statusapproval: leave.approvalStatus || "Waiting for Approval",
            approvalStatus: (
              <span
                style={{
                  color:
                    leave.approvalStatus === "Recruitment in progress"
                      ? "#f7dc6f" // Dark Green
                      : leave.approvalStatus === "Rejected"
                        ? "#e74c3c" // Dark Red
                        : leave.approvalStatus === null
                          ? "#f39c12" // Orange for Pending
                          : "#000",
                  fontWeight: 600,
                  padding: "6px 12px",
                  textAlign: "center",
                }}
              >
                {leave.approvalStatus === null
                  ? "Waiting for Approval "
                  : leave.approvalStatus}
              </span>
            ),

            jobStatus: leave.jobStatus,
          }));
        settabledata(result);
        setsampledata(result);

        setPageState((prev) => ({ ...prev, loading: false, state: "success" }));
      } catch (error) {
        console.error("ResponseError:", error);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    }
  };

  const handleSetTabValue = (event, newValue) => {
    sessionStorage.setItem("staffReqApp", JSON.stringify(newValue));

    setTabValue(newValue);
  };

  const departmentName = [
    {
      id: "All",
      departmentName: "All",
    },

    {
      id: "Recruitment in progress",
      departmentName: "Recruitment in progress",
    },
    {
      id: "Waiting for Approval",
      departmentName: "Waiting for Approval",
    },
    {
      id: "Rejected",
      departmentName: "Rejected",
    },
    {
      id: "Closed",
      departmentName: "Closed",
    },
  ];

  const [Departmentnames, setnames] = useState({
    depatmentdate: departmentName,
  });

  departmentName.forEach((data) => console.log(data));

  useEffect(() => {
    if (Department && Status) {
      // Filterfunction()
    }
  }, [Department, Status]);

  const [departmentnames, setdepartmentnames] = useState([]);

  const onDepartmentdata = async () => {
    const query = `query {
        allDepartment {
            id
            departmentName
            departmentCode
        }
    }`;

    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const departmentList = response.data.data.allDepartment;
      setdepartmentnames(departmentList);
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };

  const [access, setaccess] = useState(false);

  console.log("Sampledata:", tabledata);

  const onRowClick = (e) => {
    console.log("jshdjssd:", e);

    console.log("onDepartmentListClick:", e?.id, e);
    if (e?.id) {
      // if (
      //   AccessData.some(
      //     (item) => item.module === "Staff Request Approval" && item.can_access
      //   )
      // ) {
      //   nav(`/staff-request/approval-screen?id=${e?.id}`);
      // } else {
      //   nav(`/staff-request/create-Staffrequest?id=${e?.id}`);
      // }
      console.log(tabValue, "tabvall");
      if (tabValue == "mylist") {
        sessionStorage.removeItem("canapprovestaffrequest");
      } else if (tabValue == "teamlist") {
        sessionStorage.setItem("canapprovestaffrequest", true);
      } else {
        sessionStorage.removeItem("canapprovestaffrequest");
      }

      nav(`/staff-request/approval-screen?id=${e?.id}`);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                margin={1}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Staff Request
                  </MaterialTypography>
                  {/* <MaterialTypography variant="caption" color="text">
                                List of Employee Salary that you can get details of Employee Salary.
                            </MaterialTypography> */}
                </Stack>
                <MaterialBox alignItems="center" width="60%">
                  <MaterialBox width="80%">
                    <AppBar position="static">
                      <Tabs
                        orientation={tabsOrientation}
                        value={tabValue}
                        onChange={handleSetTabValue}
                        sx={{ backgroundColor: "transparent" }}
                      >
                        {AccessData &&
                          Array.isArray(AccessData) &&
                          AccessData.some(
                            (item) =>
                              item.module === "Staff Request" &&
                              item.component === "HrApproval" &&
                              item.can_access,
                          ) && <Tab label="HR List" value="hrlist" />}
                        {/* {AccessData &&
                        Array.isArray(AccessData) &&
                        AccessData.some(
                          (item) =>
                            item.module === "RegularaizationRequest" &&
                            item.component === "HrApproval" &&
                            item.can_access
                        ) && */}

                        {/* } */}

                        {AccessData &&
                          Array.isArray(AccessData) &&
                          AccessData.some(
                            (item) =>
                              item.module === "Staff Request" &&
                              item.component === "ManagerApproval" &&
                              item.can_access,
                          ) && <Tab label="Team List" value="teamlist" />}

                        <Tab label="My List" value="mylist" />
                      </Tabs>
                    </AppBar>
                  </MaterialBox>
                </MaterialBox>
                {AccessData &&
                  Array.isArray(AccessData) &&
                  AccessData.some(
                    (item) => item.component === "AddStaff" && item.can_access,
                  ) && (
                    <Stack alignItems="" lineHeight={1}>
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<AddIcon />}
                        onClick={handleclick}
                      >
                        Add Profile
                      </MaterialButton>
                    </Stack>
                  )}
              </Stack>

              <Stack
                direction="row"
                //   justifyContent="space-between"
                //   alignItems="center"
                marginTop={0}
                spacing={0}
              >
                {/* {AccessData &&
                  Array.isArray(AccessData) &&
                  AccessData.some(
                    (item) => item.component === "HrApproval" && item.can_access
                  ) && (
                    <Stack>
                      <MaterialBox lineHeight={1} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          color="black"
                          lineHeight={3}
                        >
                          Department
                        </MaterialTypography>
                      </MaterialBox>

                      <MaterialSelect
                        name="department"
                        value={Department}
                        customStyles={{ optionPadding: 20 }}
                        onChange={handlechangeDep}
                        options={[
                          { value: "All", label: "All" }, // Manually adding the "All" option
                          ...departmentnames.map((value) => ({
                            value: value.id,
                            label: value.departmentName,
                          })),
                        ]}
                        error={false}
                        // success={true}
                        //   isClearable
                      />
                    </Stack>
                  )} */}

                <Stack marginLeft={2}>
                  <MaterialBox lineHeight={1} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      lineHeight={3}
                      color="black"
                    >
                      Status
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialSelect
                    name="status"
                    value={Status} // Set the selected value here
                    customStyles={{ optionPadding: 20 }}
                    onChange={handlechange}
                    options={Departmentnames.depatmentdate.map((value) => ({
                      value: value.id,
                      label: value.departmentName,
                    }))}
                    error={false}
                    // success={true}
                    // isClearable
                  />
                </Stack>
              </Stack>
            </>
          }
        />
        <MaterialDataGrid
          // customHeight={550}
          // rows={SalaryStructureListTable.rows}
          rows={tabledata}
          columns={SalaryStructureListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onRowClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No staff request found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any staff request details. Click on the
                  "Add Profile" button to start adding staff request details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default StaffRequestTable;
